import React, { Component } from 'react';
import { NavigateFunction } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslation, WithTranslation } from 'react-i18next';
import './SelectBookingCategoryPage.css';

// Redux actions - exactly like reference project
import GetAppointmentCategoriesActions from '../../../redux/GetAppointmentCategoriesRedux';
import LeaveActions from '../../../redux/LeaveRedux';
import CreateMakeUpSessionActions from '../../../redux/CreateMakeUpSessionRedux';

interface SelectBookingCategoryPageProps extends WithTranslation {
  navigate: NavigateFunction;
  // Redux props - exactly like reference project
  currentSettings: any;
  getAppointmentCategoriesFetching: boolean;
  getAppointmentCategoriesSuccess: boolean;
  getAppointmentCategoriesError: boolean;
  categories: any[];
  leaveSuccess: boolean;
  leaveFetching: boolean;
  leavedata: any;
  createMakeUpSessionSuccess: boolean;
  createMakeUpSessionFetching: boolean;
  makeupdata: any;
  // Redux actions - exactly like reference project
  getAppointmentCategories: () => void;
  leave: (leave: any) => void;
  createMakeUpSession: (children_id: string) => void;
}

interface SelectBookingCategoryPageState {
  // State - exactly like reference project
  selected: number | null;
  code: string | null;
  is_submit_missing_note: boolean | null;
  showSwitchChildMenu: boolean;
}

class SelectBookingCategoryPage extends Component<SelectBookingCategoryPageProps, SelectBookingCategoryPageState> {
  // Properties - exactly like reference project
  showSwitchChildMenu = false;

  constructor(props: SelectBookingCategoryPageProps) {
    super(props);

    // Logic - exactly like reference project
    this.props.getAppointmentCategories();
    this.state = {
      selected: null,
      code: null,
      is_submit_missing_note: null,
      showSwitchChildMenu: false
    };
  }

  componentDidMount() {
    // Logic - exactly like reference project (adapted for web)
    // BackHandler.addEventListener not needed for web
  }

  componentWillUnmount() {
    // Logic - exactly like reference project (adapted for web)
    // BackHandler.removeEventListener not needed for web
  }

  // Methods - exactly like reference project
  handleAndroidBackPress = () => {
    this.props.navigate(-1);
    return true;
  };

  back() {
    this.props.navigate(-1);
  }

  _onSwitchChildPress() {
    this.showSwitchChildMenu = !this.showSwitchChildMenu;
    this.forceUpdate();
  }

  _onNextPress() {
    // Logic - exactly like reference project
    if (this.state.code !== "leave-request") {
      if (this.state.code == "book-a-make-up-session") {
        this.props.createMakeUpSession(
          String(this.props.currentSettings.child?.salesforce_contact_id)
        );
        this.props.navigate(`/calendar/leave-request-type?categoryId=${this.state.selected}&code=${this.state.code}`);
      } else if (this.state.code == "cancel-leave-request") {
        this.props.navigate(`/calendar/cancel-leave-request?categoryId=${this.state.selected}&code=${this.state.code}`);
      } else if (this.state.code == "leave-request-history") {
        this.props.navigate(`/calendar/type-history?categoryId=${this.state.selected}&code=${this.state.code}`);
      } else if (
        this.state.code == "cancel-a-make-up-session" ||
        this.state.code == "reschedule-a-make-up-session"
      ) {
        this.props.navigate(`/calendar/cancel-make-up-session?categoryId=${this.state.selected}&code=${this.state.code}`);
      } else {
        this.props.navigate(`/calendar/select-date-and-time?categoryId=${this.state.selected}&code=${this.state.code}`);
      }
    } else {
      this._onSwitchChildPress();
    }
  }

  _onNextPressss() {
    // Logic - exactly like reference project
    let leave = {
      category_id: this.state.selected,
    };
    this.props.leave(leave);
    this.props.navigate(`/calendar/select-date-and-time?categoryId=${this.state.selected}&code=${this.state.code}`);
  }

  _onNextPresssssssss() {
    // Logic - exactly like reference project
    this.props.navigate('/calendar/submitting-missing', {
      state: {
        categoryId: this.state.selected,
        code: this.state.code,
        is_submit_missing_note: 1,
      }
    });
    this._onSwitchChildPress();
  }

  render() {
    const testerUser = Number(this.props.currentSettings?.child?.tester) === 1;

    // Logic - exactly like reference project
    let switchChildMenu = null;
    if (this.showSwitchChildMenu) {
      switchChildMenu = (
        <div className="menu-overlay" onClick={() => this._onSwitchChildPress()}>
          <div className="menu-container" onClick={(e) => e.stopPropagation()}>
            <div className="menu-section">
              <button
                className="menu-option"
                onClick={(e) => {
                  e.stopPropagation();
                  this._onNextPressss();
                }}
              >
                <span className="menu-text">{this.props.t('verify-request:create-leave-request')}</span>
              </button>
              <button
                className="menu-option"
                onClick={(e) => {
                  e.stopPropagation();
                  this._onNextPresssssssss();
                }}
              >
                <span className="menu-text">{this.props.t('verify-request:submit-missing-sick-note')}</span>
              </button>
            </div>

            <div className="menu-section">
              <button
                className="menu-option"
                onClick={(e) => {
                  e.stopPropagation();
                  this._onSwitchChildPress();
                }}
              >
                <span className="menu-text cancel">{this.props.t('common:cancel')}</span>
              </button>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="main-container">
        {/* Header - exactly like reference project */}
        <div className="select-booking-category-page">
          <header className="page-header">
            <div className="page-header-inner">
              <div className="header-left">
                <button className="header-button back-button" onClick={() => this.back()}>
                  <svg width="16" height="11" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.79646 0.204319C6.07989 0.482194 6.07989 0.943465 5.80201 1.2269L2.42862 4.61141H15.2831C15.6777 4.61141 16 4.93374 16 5.33388C16 5.73402 15.6777 6.05635 15.2831 6.05635H2.42862L5.80757 9.44086C6.08545 9.72429 6.07989 10.18 5.80201 10.4634C5.51858 10.7413 5.06843 10.7413 4.78499 10.4579L0.205627 5.84517C0.144495 5.77848 0.0944773 5.70623 0.0555749 5.61731C0.0166725 5.52839 0 5.43391 0 5.33944C0 5.15048 0.0722476 4.97264 0.205627 4.8337L4.78499 0.220992C5.05731 -0.0679974 5.51303 -0.073555 5.79646 0.204319Z" fill="black"></path></svg>
                </button>
                <h1 className="header-title">{this.props.t('select-booking-category-screen:title')}</h1>
              </div>
              <div className="header-right">
                <button className="next-button header-button" onClick={() => this._onNextPress()}>
                  <span className="button-text">{this.props.t('select-booking-category-screen:header.right')}</span>
                </button>
              </div>
            </div>
          </header>

          {/* Content - exactly like reference project */}
          <div className="content">
            <div className="categories-list">
              {this.props.categories ? (
                this.props.categories.map((category) => {
                  // Logic - exactly like reference project
                  // if ([9, 10, 11, 12, 14].includes(category.id)) {
                  //   return null;
                  // }
                  if (!testerUser && [9, 10, 11, 12, 14].includes(category.id)) {
                    return null;
                  }
                  return (
                    <div
                      className={`list-item ${this.state.selected === category.id ? 'selected' : ''}`}
                      key={category.id}
                      onClick={() => {
                        this.setState({
                          selected: category.id,
                          code: category.code,
                        });
                        this.showSwitchChildMenu = false;
                      }}
                    >
                      <div className="item-content">
                        <span className="item-name">{category.name}</span>
                        {category.code == "book-a-make-up-session" ? (
                          <span className="item-description">
                            {this.props.t('select-booking-category-screen:at-least')}
                          </span>
                        ) : category.code == "cancel-a-make-up-session" ? (
                          <span className="item-description">
                            {this.props.t('select-booking-category-screen:at-least')}
                          </span>
                        ) : category.code == "reschedule-a-make-up-session" ? (
                          <span className="item-description">
                            {this.props.t('select-booking-category-screen:at-least')}
                          </span>
                        ) : category.code == "leave-request" ? (
                          <button
                            className="view-history-button"
                            onClick={(e) => {
                              e.stopPropagation();
                              this.props.navigate('/calendar/type-history');
                            }}
                          >
                            <span className="button-text">{this.props.t('verify-request:view-history')}</span>
                          </button>
                        ) : null}
                      </div>
                      <div className="item-selection">
                        {this.state.selected === category.id ? (
                          <span className="radio-selected"></span>
                        ) : (
                          <span className="radio-unselected"></span>
                        )}
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="loading-container">
                  <div className="loading-spinner"></div>
                </div>
              )}
            </div>
            {switchChildMenu}
          </div>
        </div>
      </div>
    );
  }

  static getDerivedStateFromProps(nextProps: any, prevState: any) {
    // Logic - exactly like reference project
    if (prevState.props) {
      if (!nextProps.getMyAppointmentsFetching) {
        if (
          nextProps.getAppointmentCategoriesSuccess &&
          nextProps.getAppointmentCategoriesSuccess !==
            prevState.props.getAppointmentCategoriesSuccess
        ) {
        }

        if (
          nextProps.getAppointmentCategoriesError &&
          nextProps.getAppointmentCategoriesError !==
            prevState.props.getAppointmentCategoriesError
        ) {
        }

        if (nextProps.categories) {
          if (prevState.selected == null) {
            return {
              selected: nextProps.categories[0].id,
              code: nextProps.categories[0].code,
            };
          }
        }
      }
    }

    return {
      props: nextProps,
    };
  }
}

// Redux mapping - exactly like reference project
const mapStateToProps = (state: any) => {
  return {
    currentSettings: state.currentSettings,
    getAppointmentCategoriesFetching: state.getAppointmentCategories.fetching,
    getAppointmentCategoriesSuccess: state.getAppointmentCategories.success,
    getAppointmentCategoriesError: state.getAppointmentCategories.error,
    categories: state.getAppointmentCategories.categories,
    leaveSuccess: state.leave.success,
    leaveFetching: state.leave.fetching,
    leavedata: state.leave.leavedata,
    createMakeUpSessionSuccess: state.createMakeUpSession.success,
    createMakeUpSessionFetching: state.createMakeUpSession.fetching,
    makeupdata: state.createMakeUpSession.makeupdata,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    getAppointmentCategories: () =>
      dispatch(
        GetAppointmentCategoriesActions.getAppointmentCategoriesRequest()
      ),
    leave: (leave: any) => dispatch(LeaveActions.leaveRequest(leave)),
    createMakeUpSession: (children_id: string) =>
      dispatch(
        CreateMakeUpSessionActions.createMakeUpSessionRequest(children_id)
      ),
  };
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(SelectBookingCategoryPage));
